import { ButtonCopyableProps, CopyableProps } from '../types'

export const isButtonProps = (props: CopyableProps): props is ButtonCopyableProps =>
  props.renderAs === 'button' || props.renderAs === undefined
